import { Helmet } from "react-helmet";
import AddUser from "./components/addUser";
import { getTranslation } from "../../heplers/translationHelper";
import { useEffect, useState } from "react";
import UsersList from "./components/list";
import { MyTable } from "../../components";
import AlertDialog from "../../components/DeleteDialog";
import { useSnackbar } from "notistack";
import { Get, Post } from "../../actions";
import { Typography } from "@material-ui/core";
import { Delete_Customers_URL } from "../../constants/apiUrls";

export const ManageUsersList = () => {
  const [queryParams, setQueryParams] = useState({
    pageNumber: 0,
    pageSize: 10,
  });
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [formData, setFormData] = useState(null);
  const [isLoadingCustomers, setIsLoadingCustomers] = useState(false);

  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [customers, setCustomers] = useState({ data: [], totalCount: 0 });

  const handlePageChange = (e, page) => {
    setQueryParams({ ...queryParams, pageNumber: page });
  };

  const handleSearch = (e) => {
    setQueryParams({ ...queryParams, searchString: e });
  };

  const handleRowsPerPageChange = (e) => {
    setQueryParams({ ...queryParams, pageSize: e.target.value });
  };

  const handleDelete = () => {
    setIsDeleting(true);
    Get(
      formData,
      Delete_Customers_URL,
      null,
      (res) => {
        setIsDeleting(false);
        enqueueSnackbar(
          getTranslation(
            "Deleted Successfully",
            "Deleted Successfully",
            "Deleted Successfully"
          ),
          {
            variant: "success",
          }
        );
        setOpenDeleteModal(false);
        setQueryParams({ ...queryParams, pageNumber: 0 });
      },
      (err) => {
        setIsDeleting(false);
        enqueueSnackbar(
          err.data
            ? err.data
            : getTranslation(
                "Something went wrong. Please Try Again.",
                "Something went wrong. Please Try Again.",
                "Something went wrong. Please Try Again."
              ),
          {
            variant: "error",
          }
        );
      }
    );
  };

  useEffect(() => {
    fetchUsers();
  }, [queryParams]);

  const fetchUsers = () => {
    setIsLoadingCustomers(true);
    Get(
      queryParams,
      "RestaurantUsers/GetAll",
      null,
      (resp) => {
        if (resp && resp.data && resp.data.items) {  // Corrected response access
          console.log("API Response:", resp.data.items); 
          setCustomers({
            data: resp.data.items, 
            totalCount: resp.data.totalItems, 
          });
        } else {
          console.error("Invalid response format:", resp);
        }
        setIsLoadingCustomers(false);
      },
      (error) => {
        console.error("API Error:", error);
        setIsLoadingCustomers(false);
      }
    );
  };
  

  const handleSubmitUpsert = (values) => {
    setIsSubmitting(true);
    if(formData){
      // Update
      Post(
        values,
        "RestaurantUsers/Update",
        null,
        (resp) => {
          setIsSubmitting(false);
          enqueueSnackbar(getTranslation(formData?.id? "User updated successfully!" : "User added successfully!"), { variant: "success" });  
                  setOpenEditDialog(false);
          fetchUsers();
        },
        (error) => {
          enqueueSnackbar(getTranslation("User already exists."), { variant: "error" });
          setIsSubmitting(false);
        }
      );
    }else{
      // Add
      Post(
        values,
        "RestaurantUsers/Add",
        null,
        (resp) => {
          setIsSubmitting(false);
          enqueueSnackbar(getTranslation("User added successfully"), { variant: "success" });
          setOpenEditDialog(false);
          fetchUsers();
        },
        (error) => {
          enqueueSnackbar(getTranslation("User already exists."), { variant: "error" });
          setIsSubmitting(false);
        }
      );      
    }
 
  };

  return (
    <>
      <div>
        <Helmet>
          <title>
            {getTranslation("Manage Users", "Manage Users", "Manage Users")}
          </title>
        </Helmet>
        <MyTable
  title={getTranslation("Users", "Users", "Users")}
  loading={isLoadingCustomers}
  viewSearch
  onSearch={handleSearch}
  colums={columns}
  rowsPerPage={queryParams.pageSize}
  handleChangePage={handlePageChange}
  handleChangeRowsPerPage={handleRowsPerPageChange}
  page={queryParams.pageNumber}
  rows={customers.data} 
  count={customers.totalCount} 
  viewEdit
  onEdit={(row) => {
    if(!row.roles?.include('Customer')){
    setFormData(row);
    setOpenEditDialog(true);
  } else{
    enqueueSnackbar(getTranslation("Owner cannot be modified from here, please contact admin"))
  }}
  }
  onCreate={() => {
    setOpenEditDialog(true);
    setFormData(null);
  }}
  viewCreate
/>
        <AddUser
          formData={formData}
          open={openEditDialog}
          onClose={() => {
            setOpenEditDialog(false);
            setFormData(null);
          }}
          onSubmit={handleSubmitUpsert}
        />
        <AlertDialog
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          deleting={isDeleting}
          onSubmit={handleDelete}
        />
      </div>
    </>
  );
};

const columns = [
  {
    label: getTranslation("Full Name", "Full Name", "Full Name"),
    id: "firstName",
    component: ({ row }) => (
      <Typography>
        {row.firstName} {row.lastName}
      </Typography>
    ),
  },

  {
    label: getTranslation("Email", "Email", "Email"),
    id: "email",
    component: ({ row }) => <Typography>{row.email}</Typography>,
  },
  {
    label: getTranslation("Roles", "Roles", "Roles"),
    id: "roles",
    component: ({ row }) => <UserRoles id={row.id}/>,
  },
];

const UserRoles=({id})=>{
  const [roles,setRoles]=useState("")
  useEffect(()=>{
    Get(
      {id},
      "RestaurantUsers/GetUserRoles",
      null,
      (resp) => {
        setRoles(resp.data)
      },
      (error) => {
        console.error("API Error:", error);
        // setIsLoadingCustomers(false);
      }
    );
  },[id])
  return <Typography>{roles}</Typography>
}